import {create} from "zustand";

const useDriverStore = create((set) => ({
    isSuccess: false,

    setIsSuccess: (status) => set({isSuccess: status}),
}));

export default useDriverStore